import { Expose } from '@nts/std/serialization';
import { GridFieldMetaDataInterface } from '@nts/std/interfaces';
import { SimpleFieldMetaData } from './simple-field-meta-data';

export class GridFieldMetaData extends SimpleFieldMetaData implements GridFieldMetaDataInterface {

  @Expose()
  isAutoSize: boolean;

  @Expose()
  width: number;
}
